<template>
	<div class="invoiceCt layui-layout layui-layout-admin" style="background:#fff;">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				<i @click="setClass(1)" v-if="showClass!=1" class="layui-icon-left layui-icon px20 pointer" style="margin-right:20px;"></i> 发票管理
			</div>
		</div>
		<div v-show="showClass==1">
			<div class="sxBox">
				<div class="layui-form f_row al_itm">
					<span>可开票金额</span>
					<div class="layui-inline f_row al_itm margin_l20">
						{{hasMoney}}
					</div>
					<span style="margin-left: 5px;">元</span>
					<button @click="setClass(2)" type="button" class="layui-btn zt_color margin_l20">立即开票</button>
				</div>
			</div>
			<div>
				<table class="layui-table align_center" id="orders" style="width:90%;margin:0 5%;">
					<colgroup>
						<col width="100">
						<col width="150">
						<col>
						<col>
						<col>
						<col>
						<col>
					</colgroup>
					<thead>
						<tr>
							<th class="align_center">序号</th>
							<th class="align_center">开票金额</th>
							<th class="align_center">公司</th>
							<th class="align_center">联系人</th>
							<th class="align_center">联系电话</th>
							<th class="align_center">收件地址</th>
							<th class="align_center">申请时间</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in datas" :key="i">
							<td>{{i+1}}</td>
							<td>{{item.money}}</td>
							<td>{{item.company_name}}</td>
							<td>{{item.name}}</td>
							<td>{{item.mobile}}</td>
							<td>{{item.address}}</td>
							<td>{{item.time}}</td>
						</tr>
						<tr v-if="datas.length == 0">
							<td style="padding: 5px 30px 0;text-align: center;line-height: 50px;" colspan="7">暂无数据</td>
						</tr>
					</tbody>
				</table>
				<div id="lypages" style="margin-left: 5%;"></div>
			</div>
		</div>
		<div v-show="showClass==2">
			<form class="layui-form kp px16" style="padding: 30px;" action="" id="form">
				<div class="layui-form-item">
					<label class="layui-form-label">开票金额</label>
					<div class="layui-input-inline">
						<span style="line-height: 39px;">{{hasMoney}}</span>
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label">公司名称</label>
					<div class="layui-input-inline">
						<input type="text" name="names" lay-reqText="请输入公司名称" lay-verify="required" placeholder="请输入公司名称" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label">机构代码</label>
					<div class="layui-input-inline">
						<input type="text" name="codes" lay-reqText="请输入机构代码" lay-verify="required" placeholder="请输入机构代码" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label">收件人</label>
					<div class="layui-input-inline">
						<input type="text" name="mans" lay-reqText="请输入收件联系人" lay-verify="required" placeholder="请输入收件联系人" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label">联系电话</label>
					<div class="layui-input-inline">
						<input type="phone" name="phone" lay-reqText="请输入联系电话" lay-verify="required|phone" placeholder="请输入联系电话" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label" @click="selAddress">收件地址</label>
					<div class="layui-input-inline" style="display: flex;width: auto;">
						<div class="msg" v-if="selAddr != ''" style="margin-right: 20px;">
							<div style="line-height: 39px">{{selAddr.province}} {{selAddr.city}} {{selAddr.area}} {{selAddr.address}}</div>
						</div>
						<div class="layui-btn zt_color" @click="selAddress">
							收件地址<i class="layui-icon layui-icon-right" style="position: relative;top: 2px;left: 5px;"></i>
						</div>
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label"></label>
					<div class="layui-input-inline">
						<button class="nextBtns pointer zt_color layui-btn" style="width:270px;" lay-submit lay-filter="getInvoice">提交</button>
					</div>
				</div>
			</form>
		</div>
		<!--弹出层-->
		<div id="address" style="display: none;margin: 20px 30px 60px 30px;">
			<table class="layui-table" lay-skin="nob">
				<colgroup>
					<col width="150">
					<col width="200">
					<col>
				</colgroup>
				<thead>
					<tr>
						<th class="align_center"></th>
						<th class="align_center">姓名</th>
						<th class="align_center">电话</th>
						<th class="align_center">地址</th>
						<th class="align_center">操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item,i) in address" :key="i">
						<td class="align_center">
							<span v-if="item.is_default" class="zt_color txt_white blocks" style="width:55px;margin:0 auto;">默认</span>
						</td>
						<td class="align_center">{{item.name}}</td>
						<td class="align_center">{{item.mobile}}</td>
						<td class="align_center" style="width:40%;">{{item.province+ item.city + item.area + item.address}}</td>
						<td class="align_center">
							<span @click="setTheAddr(item)" class="pointer" style="color:rgb(255, 152, 0);">选择</span>
						</td>
					</tr>
				</tbody>
			</table>
			<div v-if='address == [] || address.length == 0 || !address' style="width: 100%;line-height: 100px;text-align: center;color: #ccc;font-size: 18px;">暂无数据</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'invoiceCt',
		data() {
			return {
				showClass: 1,
				hasMoney: 0,
				tables: '',
				formss: '',
				datas: [],
				pages: 1,
				limit: 10,
				count: 1,
				address: [],
				selAddr: ''
			}
		},
		created() {
			this.getData();
		},
		mounted() {
			let _this = this;
			layui.use(['table', 'form', 'laypage'], () => {
				this.tables = layui.table;
				this.forms = layui.form;
				this.forms.on('submit(getInvoice)', function(data) {
					if(_this.selAddr == '') {
						layer.msg('请选择收件地址', {
							icon: 2,
							anim: 6
						})
						return false;
					}
					let address = _this.selAddr.province + _this.selAddr.city + _this.selAddr.area + _this.selAddr.address;
					api.addInvoice({
						token: _this.getCookie('token'),
						company_name: data.field.names,
						company_code: data.field.codes,
						money: _this.hasMoney,
						name: data.field.mans,
						mobile: data.field.phone,
						address: address,
					}).then((res) => {
						if(res.code == 1) {
							layer.msg('开票成功', {
								icon: 1,
								anim: 5
							})
							document.getElementById("form").reset()
							_this.forms.render();
							api.getInvoiceLog({
								token: _this.getCookie('token'),
								page: _this.pages,
								limit: _this.limit
							}).then((res1) => {
								if(res1.code == 1) {
									_this.getData();
									_this.showClass = 1;
								}
							})
						}
					})
					return false;
				});

			});
		},
		methods: {
			getData() {
				let _this = this;
				layui.use(['laypage'], () => {
					var laypage = layui.laypage;
					api.getInvoiceLog({
						token: _this.getCookie('token'),
						page: _this.pages,
						limit: _this.limit
					}).then((res) => {
						if(res.code == 1) {
							for(let i = 0; i < res.data.list.length; i++) {
								res.data.list[i].time = _this.getTimes2(res.data.list[i].createtime);
							}
							_this.hasMoney = res.data.money ? res.data.money : 0;
							_this.datas = res.data.list;
							_this.count = res.data.count;
						} else {
							_this.datas = [];
						}
						laypage.render({
							elem: 'lypages', //注意，这里的 lypages 是 ID，不用加 # 号
							theme: '#4876FF',
							curr: _this.pages,
							count: _this.count,
							limit: 10,
							jump: function(obj, first) {
								//首次不执行
								if(!first) {
									_this.pages = obj.curr;
									_this.getData();
								}
							}
						});
					})
				})
			},
			setClass(e) {
				if(this.hasMoney < 10000) {
					layer.msg('需要可开票金额达到10000元以上', {
						icon: 2,
						anim: 6
					})
					return false;
				}
				this.showClass = e;
			},
			selAddress() {
				let _this = this;
				layui.use(['layer', 'table'], () => {
					let layer = layui.layer;
					let table = layui.table;
					api.getAddressList({ //获取收货地址
						token: _this.getCookie('token'),
					}).then((res) => {
						if(res.code == 1) {
							_this.address = res.data;
							layer.open({
								type: 1,
								title: '选择收货地址',
								content: $('#address'),
								shade: 0,
								area: '1000px'
							});
						} else {
							layer.msg('获取收货地址失败', {
								icon: 2,
								anim: 6
							})
						}
					})
				})
			},
			setTheAddr(item) {
				this.selAddr = item;
				layer.closeAll();
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.invoiceCt {
		font-family: SourceHanSansSC;
	}
	
	.invoiceCt .kp input {
		width: 270px;
	}
	
	.sxBox {
		padding: 20px 5%;
	}
</style>


// WEBPACK FOOTER //
// src/components/invoiceCt.vue